(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-logo-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.custom-logo-list__slider');
  const prevButton = document.querySelector('.custom-logo-list__arrow--prev');
  const nextButton = document.querySelector('.custom-logo-list__arrow--next');
  
  if (!container || !prevButton || !nextButton) return;
  
  let scrollAmount;
  
  // Function to calculate the scroll amount based on screen size
  function updateScrollAmount() {
    // On mobile (small screens), scroll one item at a time
    if (window.innerWidth <= 768) {
      // Get the width of a single item including gap
      const firstItem = container.querySelector('.custom-logo-list__item');
      if (firstItem) {
        scrollAmount = firstItem.offsetWidth;
      } else {
        scrollAmount = container.offsetWidth * 0.8; // Fallback to 80% of container width
      }
    } else if (window.innerWidth <= 991) {
      // On tablets, scroll half the container
      scrollAmount = container.offsetWidth * 0.5;
    } else {
      // On desktop, scroll about a third of the container
      scrollAmount = container.offsetWidth * 0.33;
    }
  }
  
  // Initialize scroll amount
  updateScrollAmount();
  
  // Update scroll amount on window resize
  window.addEventListener('resize', updateScrollAmount);
  
  prevButton.addEventListener('click', function() {
    container.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });
  
  nextButton.addEventListener('click', function() {
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
  
  // Hide arrows if there's nothing to scroll
  function checkScrollable() {
    const isScrollable = container.scrollWidth > container.clientWidth;
    prevButton.style.display = isScrollable ? 'flex' : 'none';
    nextButton.style.display = isScrollable ? 'flex' : 'none';
  }
  
  // Check on load and on resize
  checkScrollable();
  window.addEventListener('resize', checkScrollable);
});

  } catch(e) { console.error(e); }
})();
})();
